
import {
    apiErrorCatch,
    apiRequest,
    apiSign
} from "@/common/http";
import {
    Menu
} from "@/components/cigo-admin-core/utils/types";
import cigoLayer from "@/components/cigo-layer";
import CigoIconFont from "@/components/cigo-ui/unit/basic/cigo-icon-font.vue";
import {
    useForm
} from "@ant-design-vue/use";
import {
    toArray
} from "lodash";
import {
    defineComponent,
    onMounted,
    reactive,
    ref,
    toRaw,
    toRef,
    toRefs,
    unref,
    watch
} from "vue";
export default defineComponent({
    name: "CigoEditRule",
    components: {
        CigoIconFont
    },
    props: {
        layerData: {
            type: Object,
            default: {}
        }
    },
    setup(props, ctx) {
        let formDataRef = reactive({
            id: props.layerData.menuCurr ? props.layerData.menuCurr.id : null,
            type: props.layerData.menuCurr ? props.layerData.menuCurr.type : 0, //节点类型（0-系统菜单；1-权限节点非菜单；2-按钮）
            pid: props.layerData.menuCurr ?
                props.layerData.menuCurr.pid : props.layerData.menuParent ?
                props.layerData.menuParent.id : 0,
            path: props.layerData.menuCurr ?
                props.layerData.menuCurr.path : props.layerData.menuParent ?
                props.layerData.menuParent.path +
                props.layerData.menuParent.id +
                "," : "0,",
            title: props.layerData.menuCurr ?
                props.layerData.menuCurr.title : "",
            icon: props.layerData.menuCurr ?
                props.layerData.menuCurr.icon : "cigoadmin-icon-menu",
            component_name: props.layerData.menuCurr ?
                props.layerData.menuCurr.component_name : "",
            can_not_close_opentab: props.layerData.menuCurr ?
                props.layerData.menuCurr.can_not_close_opentab : 0,
            can_not_record_opentab: props.layerData.menuCurr ?
                props.layerData.menuCurr.can_not_record_opentab : 0,
            can_not_cache: props.layerData.menuCurr ?
                props.layerData.menuCurr.can_not_cache : 0,
            url: props.layerData.menuCurr ? props.layerData.menuCurr.url : "",
            target_type: props.layerData.menuCurr ?
                props.layerData.menuCurr.target_type : "content-page", //content-page：右侧页面；layer-win：弹窗窗口；_blank：新打开页面
            summary: props.layerData.menuCurr ?
                props.layerData.menuCurr.summary : "",
            group: props.layerData.menuCurr ?
                props.layerData.menuCurr.group : "",
            group_sort: props.layerData.menuCurr ?
                props.layerData.menuCurr.group_sort : 100,
            sort: props.layerData.menuCurr ? props.layerData.menuCurr.sort : 100
        });

        const formItemRules = reactive({
            title: [{
                required: true,
                message: "请输入节点名"
            }],
            url: [{
                required: true,
                message: "请配置路由"
            }],
            component_name: [{
                required: true,
                message: "请配置唯一组件/节点名"
            }],
            sort: [{
                    required: true,
                    message: "请配置节点排序"
                },
                {
                    type: "integer",
                    transform: (value: any) => {
                        return Number(value);
                    },
                    message: "排序为正整数"
                }
            ],
            group_sort: [{
                    required: true,
                    message: "请配置分组排序"
                },
                {
                    type: "integer",
                    transform: (value: any) => {
                        return Number(value);
                    },
                    message: "排序为正整数"
                }
            ]
        });
        const {
            resetFields,
            validate,
            validateInfos,
            mergeValidateInfo
        } = useForm(formDataRef, formItemRules);
        const filterParentMenuOption = (inputVal: string, option: any) => {
            return (
                option.props.itemData &&
                option.props.itemData.title.indexOf(inputVal) != -1
            );
        };
        const handleParentMenuChange = (value: any, option: any) => {
            formDataRef.path = value ?
                option.props.itemData.path + value + "," :
                "0,";
        };

        const doSubmit = (e: any) => {
            e.preventDefault();
            validate()
                .then(() => {
                    let params = toRaw(formDataRef);
                    apiRequest.v1
                        .post(
                            props.layerData.menuCurr ? "/edit/Rule" : "/add/Rule",
                            params, {
                                headers: apiSign(params)
                            }
                        )
                        .then(response => {
                            ctx.emit("notify", "refresh");

                            //提示及关闭窗口
                            cigoLayer.msg(response.data.msg);
                            ctx.emit("close");
                        })
                        .catch(apiErrorCatch.v1);
                })
                .catch(err => {
                    console.log("error", err);
                });
        };

        const cancel = () => {
            ctx.emit("close");
        };

        return {
            labelCol: {
                span: 6
            },
            wrapperCol: {
                span: 16
            },
            formDataRef,
            validateInfos,
            filterParentMenuOption,
            handleParentMenuChange,
            doSubmit,
            cancel
        };
    }
});
